import { FC, memo, useMemo } from 'react';

import { CellStyled } from './SelectCell.styles';
import { SelectCellProps } from './SelectCell.types';

export const SelectCell: FC<SelectCellProps> = memo((props) => {
    const { invalid, readOnly, children, columnDefinition, ...otherProps } = props;

    const preparedColumnDefinition = useMemo(
        () => ({
            ...columnDefinition,
            spacing: '0' as const,
        }),
        [columnDefinition]
    );

    return (
        <CellStyled {...otherProps} columnDefinition={preparedColumnDefinition} $invalid={invalid} $readOnly={readOnly}>
            {children}
        </CellStyled>
    );
});

SelectCell.displayName = 'SelectCell';
